/**
 * @ngdoc controllers
 * @memberof mercury.modules.cogs
 * @name ReportsCogsSummaryCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.cogs')
.controller('ReportsCogsSummaryCtrl', ["title", "reporttime", "ReportCogs", "ReportPosItems", "ReportsCogsSummaryService", "$scope", "$q", function(title, reporttime, ReportCogs, ReportPosItems, ReportsCogsSummaryService, $scope, $q) {
  title.set('Overview');
  reporttime.setAllowedTypes(['week', 'month']);

  var allResults;
  $scope.reportResults = [];
  $scope.categories = [
    {values: [], key: 'All'}
  ];
  $scope.selectedCategoryIds = $scope.categories[0].values;
  $scope.cogsGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Cogs Percent', type: 'number', key: 'costPerc', filter: 'percent'}
  ];
  $scope.cogsGraphOptions = {
    vAxis: {
      format: '#\'%\''
    }
  };

  $scope.loading = $q.all({
    productSummary: ReportCogs.getProductsSummary(reporttime.start(), reporttime.end(), reporttime.interval()),
    categories: ReportPosItems.itemCategories()
  });

  $scope.loading.then(function(result) {
    allResults = result.productSummary;

    result.categories.forEach(function(cat) {
      $scope.categories.push(cat);
    });

    $scope.setCategory();
  });

  // Handler function for when the user selects a category using the combobox in the report.
  $scope.setCategory = function() {
    $scope.reportResults = ReportsCogsSummaryService.parseResults(allResults, $scope.selectedCategoryIds);
  };
}]);
